import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import { Link } from "react-router-dom";
import MeetingDate from "../components/MeetingDate";
import MeetingType from "../components/MeetingType";
import MeetingCreateForm from "../components/MeetingCreateForm";

const classes = {
	vCenter: {
		display: "flex",
		alignItems: "center"
	},
	textField: {
		width: "100%"
	},
	card: { padding: "20px" }
};

const currencies = [
	{
		value: "marketing",
		label: "Marketing"
	},
	{
		value: "tech",
		label: "Tech"
	},
	{
		value: "support",
		label: "Support"
	},
	{
		value: "lab",
		label: "Lab"
	}
];

export default class settings extends Component {
	state = {
		title: "",
		venue: "",
		type: "..."
	};

	handleChange = () => {
		console.log("wow");
	};
	render() {
		return (
			<Grid container>
				<Grid xs={12}>
					<Paper style={classes.card}>
						{/* <h5 style={{ textAlign: "center" }}>Create New Meeting</h5> */}
						<MeetingCreateForm width="60%" />
					</Paper>
				</Grid>
			</Grid>
		);
	}
}
